<template>
	<div class="info-app">
		<div class="info">
			<div class="user-title">
				<span>基本资料</span>
			</div>
			<div>
				<el-form label-width="100px">
							<el-form-item label="用户电话：" disabled >
    					<el-input v-model="modifyPhone.oldPhone" 	disabled  ></el-input>
							 </el-form-item  >
					<!-- <el-form-item label="手机号码：">
						<div>
						
							<span>{{userMobile.mobile}}</span>
							<el-dialog :visible.sync="showPhoneDialog" width="400px">
								<div class="user-phone">
									<h3>修改手机号码</h3>
									<el-form :model="userMobile.mobile ">
										<el-form-item
											:class="{ 'is-error': alterFormMsg.oldPhoneMsg != '' }"
										>
											<el-input
												:value="modifyPhone.oldPhone"
												placeholder="请输入手机号码"
												disabled
											></el-input>
											<div
												class="login-err"
												:class="{
													'login-err-active': alterFormMsg.oldPhoneMsg != '',
												}"
											>
												{{ alterFormMsg.oldPhoneMsg }}
											</div>
										</el-form-item>
										<el-form-item
											class="user-phone-code"
											:class="{ 'is-error': alterFormMsg.oldCodeMsg != '' }"
										>
											<el-input
												v-model="alterForm.oldCode"
												placeholder="请输入验证码"
											></el-input>
											<div
												class="login-err"
												:class="{
													'login-err-active': alterFormMsg.oldCodeMsg != '',
												}"
											>
												{{ alterFormMsg.oldCodeMsg }}
											</div>
											<el-button
												@click="getCode(1)"
												:disabled="oldCodeText !== '获取验证码'"
												>{{ oldCodeText }}</el-button
											>
										</el-form-item>
										<el-form-item
											:class="{ 'is-error': alterFormMsg.newPhoneMsg != '' }"
										>
											<el-input
												v-model="alterForm.newPhone"
												placeholder="请输入新手机号码"
											></el-input>
											<div
												class="login-err"
												:class="{
													'login-err-active': alterFormMsg.newPhoneMsg != '',
												}"
											>
												{{ alterFormMsg.newPhoneMsg }}
											</div>
										</el-form-item>
										<el-form-item
											class="user-phone-code"
											:class="{ 'is-error': alterFormMsg.newCodeMsg != '' }"
										>
											<el-input
												v-model="alterForm.newCode"
												placeholder="请输入验证码"
												maxlength="6"
											></el-input>
											<div
												class="login-err"
												:class="{
													'login-err-active': alterFormMsg.newCodeMsg != '',
												}"
											>
												{{ alterFormMsg.newCodeMsg }}
											</div>
											<el-button
												@click="getCode(2)"
												:disabled="newCodeText !== '获取验证码'"
												>{{ newCodeText }}</el-button
											>
										</el-form-item>
										<el-button
											type="primary"
											class="user-phone-save"
											@click="changePhoneSub"
											@keyup.13.native="changePhoneSub"
											>保存</el-button
										>
									</el-form>
								</div>
							</el-dialog>
						</div>
					</el-form-item> -->
					<el-form-item label="用户昵称：">
						<el-input
							v-model="userForm.nickname"
							@keyup.enter.native="uploadUserInfo">
			</el-input>
				 </el-form-item>
			<el-form-item label="报考城市：">
					 <el-select v-model="	suerSun.cityId"  @change="setCityId" placeholder="请选择">
    				<el-option
     				 v-for="item in citylist"
      			:key="item.id"
     				:label="item.areaname"
     	 			:value="item.id">
   			 	 </el-option>
  				</el-select>
				</el-form-item> 
					
			<!--  
					
						<el-select v-model="userForm.shortname" @change="changeCity">
							<el-option
								v-for="item in cityList"
								:key="item.id"
								:label="item.shortname"
								:value="item.id"
							></el-option>
						</el-select>
				 -->
					<el-form-item label="报考科目：" class="info-subject">
						<el-select v-model="suerSun.CateViceName" 	@change="fun">
							<el-option
								v-for="item in 	CateViceList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							
							></el-option>
						</el-select>
					</el-form-item>
					
					
					<el-button type="primary" class="info-save" @click="uploadUserInfo"
						>保存</el-button
					>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
 import EventBus from '../../eventBus/eventBus.js'
	export default {
		name: "info-app",
		inject: ["reload"],
		data() {
			return {
				userForm: {
					mobile: "",
					nickname: "",
					subject_city: "",
					subject: "",
					shortname: "",
					name: "",
				},	
					suerSun:{
						cityId: "",
						CateViceName:"",
						 
						}
					,
					
			  CateViceList:[
					


				],
				 CateViceLists:[
					


				],
				userinfo:[],
	
					 citylist:[],
			
				subId: "",
				alterForm: {
					oldPhone: "",
					oldCode: "",
					newPhone: "",
					newCode: "",
				},
				alterFormMsg: {
					oldPhoneMsg: "",
					oldCodeMsg: "",
					newPhoneMsg: "",
					newCodeMsg: "",
				},
				modifyPhone:{
					oldphone:"",
					newPhone:""
				}, 
				userMobile:'',
				subjectList: [],
				showPhoneDialog: false, //修改手机号码
				oldCodeText: "获取验证码",
				newCodeText: "获取验证码",
				btnDisabled: true,
			};
		},
		methods: {
			funs(){
				let userinfo = JSON.parse(localStorage.getItem('userInfo'))
				//console.log(userinfo)
				//console.log("userinfo")

				this.modifyPhone.oldPhone =  userinfo.mobile
				this.userForm.nickname = userinfo.nickname
			},
			setCityId(){
				//console.log(this.suerSun.cityId)
			},
			//修改手机号码
			alterPhone() {
				this.showPhoneDialog = true;
				this.resetForm();
			},
			//验证手机号
			checkMobile(str) {
				let re = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
				if (re.test(str)) {
					return true;
				} else {
					return false;
				}
			},
			
			// 获取验证码
			getCode(index) {
				var that = this;
				if (index == "1") {
					var i = 31;
					var that = this;
					if ((that.oldCodeText = "获取验证码")) {
						var param = {
							mobile: this.userForm.mobile,
							type: 4,
						};
						that.$get("phoneCapt", param).then((res) => {
							if (res.code == 200) {
								that.$message({
									showClose: true,
									message: "验证码发送成功！",
									type: "success",
								});
								var timer = setInterval(() => {
									i--;
									that.oldCodeText = i + "秒后重试";
									if (i < 0) {
										clearInterval(timer);
										that.oldCodeText = "获取验证码";
										i = 31;
									}
								}, 1000);
							}
						});
					}
				} else if (index == "2") {
					if (that.alterForm.newPhone == "") {
						that.alterFormMsg.newPhoneMsg = "请输入手机号码";
					} else {
						if (!that.checkMobile(that.alterForm.newPhone)) {
							that.alterFormMsg.newPhoneMsg = "请输入正确的手机号码";
						} else {
							that.alterFormMsg.newPhoneMsg = "";
							var i = 11;
							if ((that.newCodeText = "获取验证码")) {
								var param = {
									mobile: this.alterForm.newPhone,
									type: 3,
								};
								that.$get("capt", param).then((res) => {
									if (res.code == 200) {
										that.$message({
											showClose: true,
											message: "验证码发送成功！",
											type: "success",
										});
										var timer = setInterval(() => {
											i--;
											that.newCodeText = i + "秒后重试";
											if (i < 0) {
												clearInterval(timer);
												that.newCodeText = "获取验证码";
												i = 31;
											}
										}, 1000);
									}
								});
							}
						}
					}
				}
			},
			//修改手机号
			changePhoneSub() {
				var that = this;
				if (that.alterForm.oldCode == "") {
					that.alterFormMsg.oldCodeMsg = "请输入验证码";
				} else if (that.alterForm.newPhone == "") {
					that.alterFormMsg.newPhoneMsg = "请输入新手机号";
				} else if (!that.checkMobile(that.alterForm.newPhone)) {
					that.alterFormMsg.newPhoneMsg = "请输入正确的手机号";
				} else if (that.alterForm.newCode == "") {
					that.alterFormMsg.newCodeMsg = "请输入验证码";
				} else {
					var param = {
						mobile: this.userForm.mobile,
						new_mobile: this.alterForm.newPhone,
						captcha_change: this.alterForm.oldCode,
						captcha: this.alterForm.newCode,
					};
					that.$post("phoneChange", param).then((res) => {
						//console.log(res);
						if (res.code == 102) {
							that.alterFormMsg.oldCodeMsg = res.msg;
						} else if (res.code == 104) {
							that.alterFormMsg.newCodeMsg = res.msg;
						} else if (res.code == 103) {
							that.alterFormMsg.newPhoneMsg = res.msg;
						} else if (res.code == 200) {
							this.$message({
								message: res.msg,
								type: "success",
								showClose: true,
								onClose() {
									that.reload();
									// that.$router.go(0);
								},
							});
							setTimeout(() => {
								// that.$router.go(0);
								that.reload();
							}, 3000);
						}
					});
				}
			}, // 绑定回车事件
			keyupEnter() {
				var that = this;
				document.onkeydown = function (e) {
					let key = window.event.keyCode;
					if (key == 13) {
						that.changePhoneSub();
					}
				};
			},
			//重置
			resetForm() {
				this.alterForm = {
					oldPhone: "",
					oldCode: "",
					newPhone: "",
					newCode: "",
				};
				this.resetMsg();
			},
			resetMsg() {
				this.alterFormMsg = {
					oldPhoneMsg: "",
					oldCodeMsg: "",
					newPhoneMsg: "",
					newCodeMsg: "",
				};
			},



			// 获取城市
			async getCityList(){
					//console.log("info页面")
				 	const  {data:res} = await this.$api.getCity()
				 	this.citylist = res

					 //console.log(this.citylist)
			},

			// 获取科目
// 			async getSuject(){
// 				 const  {data:res} =  await this.$api.getCateVice()
// 				this.CateViceList = res
// 				//console.log(res)

// 			}		
// ,
			//获取个人信息
			// getUserInfo(uid) {
			// 	this.$loading();
			// 	var param = { uid: uid };
			// 	this.$post("userinfo", param).then((res) => {
			// 		this.userForm = res.data;
			// 		this.cityId = this.userForm.subject_city;
			// 		this.subId = this.userForm.subject;
			// 		if (res.data.nickname == null) {
			// 			this.userForm.nickname = res.data.mobile;
			// 		}
			// 	});
			// 	this.$post("citylist", param).then((res) => {
			// 		this.cityList = res.data;
			// 	});
			// 	this.getSubjectList(this.subject_city);
			// 	setTimeout(() => {
			// 		this.$loading().close();
			// 	}, 300);
			// },
			//获取报考科目
		  // 	getSubjectList(cid) {
			// 	var param = { cid: cid };
			// 	this.$post("categorylist", param).then((res) => {
			// 		this.subjectList = res.data;
			// 	});
			// },
			// changeCity() {
			// 	this.cityId = this.userForm.shortname;
			// },
			// changeSub() {
			// 	this.subId = this.userForm.name;
			// },
			// 修改昵称
			uploadUserInfo() {
				this.$api.updateNickname({nickname:this.userForm.nickname}).then(res => {
					//console.log(res)
					this.$message.success('修改成功')
					let userinfo = JSON.parse(localStorage.getItem('userInfo'))
					userinfo.nickname = this.userForm.nickname
					localStorage.setItem('userInfo',JSON.stringify(userinfo))
					EventBus.$emit('userName',this.userForm.nickname)
					// this.$router.go(0);
					
				})
			}
			// 	var that = this;
			// 	var param = {
			// 		id: this.user_id,
			// 		mobile: this.userForm.mobile,
			// 		nickname: this.userForm.nickname,
			// 		subject_city: this.cityId,
			// 		subject: this.subId,
			// 	};
			// 	var query = {
			// 		path: "/user",
			// 	};
			// 	this.$post("updateUserinfo", param).then((res) => {
			// 		this.$message({
			// 			message: "修改成功",
			// 			type: "success",
			// 			showClose: true,
			// 			duration: 2000,
			// 			onClose() {
			// 				// that.$link(query);
			// 				that.$router.go(0);
			// 			},
			// 		});
			// 		setTimeout(() => {
			// 			// this.$link(query);
			// 			that.$router.go(0);
			// 		}, 2000);
			// 		localStorage.setItem("user_name", this.userForm.nickname);
			// 	});
			// },
		},
		created() {
			// this.getUserInfo(this.user_id);
			this.keyupEnter();
			this.	getCityList();
			this.	getSuject();
			this.funs()
		},
		watch: {
			alterForm: {
				handler(newValue, oldValue) {
					this.resetMsg();
				},
				deep: true,
			},
		},
	};
</script>

<style>
	.info {
		padding: 0 40px;
	}

	.info .el-form {
		padding: 0;
	}
	.info .el-form-item__label {
		font-size: 16px;
		color: #333;
	}
	.info .el-input {
		width: 200px;
		color: #333;
	}
	.info-subject .el-input {
		width: 300px;
	}
	.info .el-form-item {
		padding: 30px 0;
		margin-bottom: 0;
		border-bottom: 1px dashed #ebebeb;
	}
	.info .el-form-item .user-alter {
		border-color:#e60012;
		color:#e60012;
		margin-left: 10px;
	}
	.info .info-save {
		width: 200px;
		margin: 30px 0 0 100px;
	}
	.user-phone {
		text-align: center;
		font-size: 20px;
		color: #666;
		background-color: #fff;
		border-radius: 10px;
	}

	.user-phone h3 {
		padding: 0 30px;
		text-align: center;
		font-size: 20px;
		border-bottom: 1px solid #f5f5f5;
		line-height: 70px;
	}
	.user-phone .el-form {
		padding: 30px;
	}
	.info .user-phone .el-form-item {
		padding: 0;
		margin-bottom: 25px;
		border-bottom: none;
	}
	.user-phone .el-input {
		width: 100%;
	}

	.user-phone-code .el-input {
		width: 220px;
		margin-right: 20px;
	}
	.user-phone-code .el-button {
		width: 100px;
		padding: 12px 0;
		border-color:#e60012;
		color:#e60012;
	}
	.user-phone .user-phone-save {
		width: 100%;
	}
	.user-phone-code .user-phone-code-active {
		border-color: #ccc !important;
		background: #ccc !important;
		color: #fff !important;
	}
</style>
